// extracted by mini-css-extract-plugin
module.exports = {"container":"stats_container_jnaiw","team":"stats_team_8hGzu","bar":"stats_bar_tT1-O","label":"stats_label_3wBDf","content":"stats_content_3SdUh"};